const globalData = {
  name: 'Kendall Whitman Photography',
  nameFirst: 'Kendall Whitman',
  nameSecond: 'Photography',
  nameFirstShort: 'KW',
  nameSecondShort: 'P',
}

export default globalData
